import { BaseMapper } from '@ps/utils';
import { FlexibilityPrices } from '@ps/survey-utils';

import { SupplierFlexibilityPricesDto } from '../dtos/supplier.dto';

export class FlexibilityPricesMapper extends BaseMapper<
  SupplierFlexibilityPricesDto,
  FlexibilityPrices
> {
  public override fromDto(
    _from: SupplierFlexibilityPricesDto,
  ): FlexibilityPrices {
    return {
      flexibility: _from.flexibility,
      currency: _from.currency,
      surveyAcpi: _from.survey_acpi,
      surveyPauseThreshold: _from.survey_pause_threshold,
      surveyPriceOverride: _from.survey_price_override,
      manualOverride: _from.manual_override,
    };
  }
}
